import React, { useState, useEffect, useMemo } from "react";
import useTrainWorthy from "./useTrainWorthy";
import VLButton from "views/uikit/Buttons/VLButton";
import styles from "./styles.module.scss";
import { VLInput } from "views/uikit/FormFields/VLInput/VLInput";

export const TrainWorthyThreshold = () => {
  const [threshold, setThreshold] = useState<string>("");
  const { updateThreshold, isLoading, initialValue, fetching } =
    useTrainWorthy();

  useEffect(() => {
    if (initialValue !== null) {
      setThreshold(initialValue);
    }
  }, [initialValue]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (threshold === "") return;

    updateThreshold(parseInt(threshold, 10));
  };

  const disabledSubmit = useMemo(
    () =>
      threshold === "" || isLoading || fetching || threshold === initialValue,
    [threshold, isLoading, fetching, initialValue],
  );

  return (
    <div className={styles.container}>
      <div className={styles.sectionTitle}>System settings</div>
      <div className={styles.content}>
        <div className={styles.header}>
          <div className={styles.title}>
            Model Training - Train-Worthy Threshold
          </div>
          <div className={styles.subTitle}>
            Define the minimum number of labeled images per class required to
            enable model training.
          </div>
        </div>
        <div className={styles.formControl}>
          <form onSubmit={handleSubmit} className={styles.form}>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <VLInput
                id="threshold-Input"
                type="text"
                value={threshold}
                onChange={(e) => {
                  const val = e.target.value;
                  if (
                    val === "" ||
                    (/^\d+$/.test(val) && parseInt(val, 10) <= 10000)
                  ) {
                    setThreshold(val);
                  }
                }}
                placeholder={fetching ? "Loading..." : "Enter threshold"}
                disabled={fetching}
                required
                className={styles.inputField}
              />
            </div>

            <VLButton
              type="primary"
              text="Save"
              htmlType="submit"
              loading={isLoading}
              disabled={disabledSubmit}
              className={styles.saveButton}
            />
          </form>
          <div className={styles.helperText}>
            Applies globally to all datasets in the workspace.
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrainWorthyThreshold;
